import SectionHead from '../components/SectionHead';
import Reveal from '../components/Reveal';
import InquiryForm from '../components/InquiryForm';
import { CONTACT } from '../content/site';
import usePageMeta from '../hooks/usePageMeta';

export default function Contact() {
  usePageMeta(
    'Contact the Commercial Solutions Team | RangeSafe',
    'Contact the RangeSafe Commercial Solutions Team for quotes, pilots, compatibility reviews and OEM conversations.'
  );
  return (
    <main className="pt-16">
      <header className="mx-auto max-w-shell px-5 pb-14 pt-20 sm:px-8 lg:pt-28">
        <SectionHead
          as="h1"
          eyebrow="Commercial Sales"
          lines={['Talk to a person']}
          lead="The Commercial Solutions Team answers quotes, pilots, compatibility reviews and OEM conversations. Verified contact details below — or use the form and your inquiry is routed to the same team."
        />
      </header>

      <div className="mx-auto grid max-w-shell gap-14 px-5 pb-24 sm:px-8 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <Reveal>
            <div className="border border-line bg-panel/40 p-6 sm:p-10" data-testid="contact-form-panel">
              <InquiryForm type="contact" submitLabel="Send to Commercial Sales" />
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <aside className="space-y-8 lg:sticky lg:top-24">
            <div className="border border-line bg-panel p-7">
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-mute">Verified contact details</p>
              <div className="mt-5 space-y-3 border-t border-line2 pt-5">
                <p className="font-mono text-sm">
                  <span className="mr-2 text-mute">Email</span>
                  <a href={`mailto:${CONTACT.commercialEmail}`} className="text-white hover:text-accent2" data-testid="contact-email">{CONTACT.commercialEmail}</a>
                </p>
                <p className="font-mono text-sm">
                  <span className="mr-2 text-mute">Support</span>
                  <a href={`mailto:${CONTACT.generalEmail}`} className="text-white hover:text-accent2" data-testid="contact-support-email">{CONTACT.generalEmail}</a>
                </p>
                <p className="font-mono text-sm">
                  <span className="mr-2 text-mute">Phone</span>
                  <a href={CONTACT.phoneHref} className="text-white hover:text-accent2" data-testid="contact-phone">{CONTACT.phone}</a>
                </p>
              </div>
              <p className="mt-6 text-xs leading-relaxed text-mute">
                Response times are not guaranteed. For anything urgent, call during business hours.
              </p>
            </div>
            <p className="text-xs leading-relaxed text-mute">
              RangeSafe's retail store is a separate website for individual purchases.
            </p>
          </aside>
        </Reveal>
      </div>
    </main>
  );
}
